import { render, staticRenderFns } from "./AlertasDetalleGrid.vue?vue&type=template&id=24c5e360&"
import script from "./AlertasDetalleGrid.vue?vue&type=script&lang=ts&"
export * from "./AlertasDetalleGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('24c5e360', component.options)
    } else {
      api.reload('24c5e360', component.options)
    }
    module.hot.accept("./AlertasDetalleGrid.vue?vue&type=template&id=24c5e360&", function () {
      api.rerender('24c5e360', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Inicio/DetalleVehiculo/AlertasDetalleGrid.vue"
export default component.exports